import HomeView from "../views/HomeView.vue";
import Home from "../views/Home";
import AboutUsView from "../views/AboutUsView.vue";
import NewsCenterView from "../views/NewsCenterView.vue";
import ContactUsView from "../views/ContactUsView.vue";
import CustomerCaseView from "../views/CustomerCaseView.vue";
import DownloadCenterView from "../views/DownloadCenterView.vue";
import ProductCenterView from "../views/ProductCenterView.vue";
import ProductDetailView from "../views/ProductDetailView.vue";
import ValueAddedServicesView from "../views/ValueAddedServicesView.vue";
import NewsDetailView from "../views/NewsDetailView.vue";
import LiveChatView from "../views/LiveChatView.vue";
// import ProductManualView from '../views/ProductManualView.vue'
// import PvideosView from '../views/PvideosView.vue'
// import UtilitysoftwareView from '../views/UtilitysoftwareView.vue'

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "/",
        name: "HomeView",
        component: HomeView,
      },
      {
        path: "/AboutUs",
        name: "AboutUs",
        component: AboutUsView,
      },
      {
        path: "/LiveChat",
        name: "LiveChat",
        component: LiveChatView,
      },
      {
        path: "/ContactUs",
        name: "ContactUs",
        component: ContactUsView,
      },
      {
        path: "/NewsDetail/:id",
        name: "NewsDetail",
        component: NewsDetailView,
      },
      {
        path: "/CustomerCase",
        name: "CustomerCase",
        component: CustomerCaseView,
      },
      {
        path: "/DownloadCenter",
        name: "DownloadCenter",
        component: DownloadCenterView,
      },
      {
        path: "/Home",
        name: "Home",
        component: HomeView,
      },
      {
        path: "/NewsCenter",
        name: "NewsCenter",
        component: NewsCenterView,
      },
      {
        path: "/ProductCenter/:id",
        name: "ProductCenter",
        component: ProductCenterView,
      },
      {
        path: "/ProductDetail/:id",
        name: "ProductDetail",
        component: ProductDetailView,
      },
      {
        path: "/ValueAddedServices",
        name: "ValueAddedServices",
        component: ValueAddedServicesView,
      },
      // {
      //   path: '/ProductManual',
      //   name: 'ProductManual',
      //   component: ProductManualView
      // },
      // {
      //   path: '/Pvideos',
      //   name: 'Pvideos',
      //   component: PvideosView
      // },
      // {
      //   path: '/tilitysoftware',
      //   name: 'tilitysoftware',
      //   component: UtilitysoftwareView
      // }
    ],
  },
];

export default routes;
